import { ToolsTranslations } from '@/lib/translations/types';

export interface CapitalTurnoverValues { revenue: number; totalCapital: number }
export interface CapitalTurnoverResult { ratio: number | null; isValid: boolean; message?: string }

// Capital turnover = Revenue / Total Capital
export function calculateCapitalTurnover(values: CapitalTurnoverValues, t?: ToolsTranslations['capitalTurnover']): CapitalTurnoverResult {
  const { revenue, totalCapital } = values;
  if (revenue < 0) return { ratio: null, isValid: false, message: t?.invalid.revenue };
  if (totalCapital <= 0) return { ratio: null, isValid: false, message: t?.invalid.totalCapital };
  const ratioRaw = revenue / totalCapital;
  const ratio = Math.round(ratioRaw * 10) / 10; // 1 decimal
  if (!isFinite(ratio)) return { ratio: null, isValid: false, message: t?.invalid.generic };
  return { ratio, isValid: true };
}


